export enum UserType {
  Library = 'library',
  PressArea = 'press',
  Single = 'user',
}

export enum RegistrationType {
  Library = 'Library',
  PressArea = 'Press Area',
  Quotation = 'Quotation',
  Contact = 'Contact',
}

export type UserApp = {
  name: string;
  modules: {
    name: string;
    entityType: string;
    entityCode: string;
    entityName: string;
    jsonData: {
      registrationStatus: Partial<
        Record<RegistrationType, 'Pending' | 'Approved' | 'Rejected'>
      >;
      registrationType: string[];
      address: {
        streetAddress: string;
        city: string;
        country: string;
        postCode: string;
        stateOrProvince: string;
        phoneNumber: string;
      };
      company: {
        name: string;
        activity?: string;
        activityType?: string;
        function?: string;
      };
      web?: string;
      media?: string;
      occupation?: string;
    };
    areas: string[];
  }[];
};

export type User = {
  name: string;
  lastName: string;
  userName: string;
  email: string;
  dynamicsUserId: string;
  languageId: string;
  phoneNumber: string;
  message: string;
  apps: UserApp[];
};

export type UserLoginPayload = {
  email: string;
  password: string;
};

export type RefreshTokenPayload = {
  accessToken: string;
  refreshToken: string;
};

export type ForgotPasswordPayload = {
  email: string;
};

export type ResetPasswordPayload = {
  email: string;
  newPassword: string;
  token: string;
};

export type UpdatePasswordPayload = {
  currentPassword: string;
  newPassword: string;
};

type BaseRegisterUserPayload = {
  store: 'workplace';
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  languageId: string;
  phoneNumber: string;
  descriptionOfYourRequest?: string;
  registrationType: RegistrationType[];
  address: {
    streetAddress: string;
    city: string;
    country: string;
    postCode: string;
    stateOrProvince: string;
    phoneNumber: string;
  };
};

type RegisterPressAreaUserPayload = BaseRegisterUserPayload & {
  web?: string;
  media?: string;
  occupation?: string;
};

type CompanyPayload = {
  name: string;
  function?: string;
  activity?: string;
  activityType?: string;
};

type RegisterLibraryUserPayload = BaseRegisterUserPayload & {
  company?: CompanyPayload;
};

type RegisterSingleUserPayload = BaseRegisterUserPayload & {
  company?: CompanyPayload;
};

export type RegisterUserPayload =
  | RegisterPressAreaUserPayload
  | RegisterLibraryUserPayload
  | RegisterSingleUserPayload;

export type UpdateUserPayload = Partial<User>;
